import React, { useState, useEffect } from "react";
import { X, Share, PlusSquare, MoreVertical, Smartphone } from "lucide-react";

export default function InstallPrompt() {
  const [show, setShow] = useState(false);
  const [os, setOs] = useState("");

  useEffect(() => {
    // Kullanıcı zaten ana ekrandan açmışsa veya daha önce kapatmışsa gösterme
    const isStandalone = window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone;
    const hasDismissed = localStorage.getItem("install_prompt_dismissed");

    if (!isStandalone && !hasDismissed) {
      const userAgent = window.navigator.userAgent.toLowerCase();
      if (/iphone|ipad|ipod/.test(userAgent)) {
        setOs("ios");
        setShow(true);
      } else if (/android/.test(userAgent)) {
        setOs("android");
        setShow(true);
      }
    }
  }, []);

  const dismiss = () => {
    localStorage.setItem("install_prompt_dismissed", "true");
    setShow(false);
  };

  if (!show) return null;

  return (
    <div style={{ position: "fixed", bottom: "80px", left: "50%", transform: "translateX(-50%)", width: "90%", maxWidth: "400px", background: "#1e293b", color: "white", padding: "16px", borderRadius: "16px", boxShadow: "0 10px 25px rgba(0,0,0,0.5)", zIndex: 9999, border: "1px solid #334155" }}>
      <button onClick={dismiss} style={{ position: "absolute", top: "12px", right: "12px", background: "none", border: "none", color: "#94a3b8", cursor: "pointer" }}>
        <X size={18} />
      </button>
      
      <div style={{ display: "flex", alignItems: "center", gap: "12px", marginBottom: "12px" }}>
        <div style={{ background: "#3b82f6", padding: "10px", borderRadius: "12px" }}>
          <Smartphone size={24} color="white" />
        </div>
        <div>
          <h4 style={{ margin: 0, fontSize: "15px", fontWeight: "bold" }}>Kolay Erişim İçin Yükleyin</h4>
          <p style={{ margin: "2px 0 0 0", fontSize: "12px", color: "#cbd5e1" }}>Uygulamayı ana ekranınıza ekleyin.</p>
        </div>
      </div>

      <div style={{ background: "#0f172a", padding: "12px", borderRadius: "8px", fontSize: "13px", color: "#e2e8f0", display: "flex", flexDirection: "column", gap: "8px" }}>
        {os === "ios" ? (
          <>
            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              1. Alt menüdeki <Share size={16} color="#3b82f6"/> <b>Paylaş</b> ikonuna dokunun.
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              2. <PlusSquare size={16} color="#3b82f6"/> <b>Ana Ekrana Ekle</b>'yi seçin.
            </div>
          </>
        ) : (
          <>
            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              1. Sağ üstteki <MoreVertical size={16} color="#3b82f6"/> <b>Menü</b> ikonuna dokunun.
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              2. <PlusSquare size={16} color="#3b82f6"/> <b>Ana Ekrana Ekle</b>'yi seçin.
            </div>
          </>
        )}
      </div>
    </div>
  );
}